import React, { ReactNode } from "react";

export interface BadgeProps {
  text: ReactNode;
}

const Badge = ({ text }: BadgeProps) => {
  return (
    <div className="inline-block px-4 py-1 text-xs font-bold text-white uppercase bg-red-600 rounded">
      {text}
    </div>
  );
};

export default Badge;
